export const getCurrentPathWithoutLastPart = (pathname: string) => {
  return pathname.slice(0, pathname.indexOf("/", 1));
};
